namespace Matrix.Dashboards {
    export interface DatasetRow {
        DatasetCode?: string;
        Name?: string;
        DatasetType?: string;
        Permission?: string;
        Properties?: { [key: string]: any };
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace DatasetRow {
        export const idProperty = 'DatasetCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Dashboards.Dataset';
        export const deletePermission = 'Administration:Dashboards';
        export const insertPermission = 'Administration:Dashboards';
        export const readPermission = 'Read:Dashboards';
        export const updatePermission = 'Administration:Dashboards';

        export declare const enum Fields {
            DatasetCode = "DatasetCode",
            Name = "Name",
            DatasetType = "DatasetType",
            Permission = "Permission",
            Properties = "Properties",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
